import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import performRequest from "../Api/request";
import { Toast } from "../Custom Components/toast";
import { CustomErrorResponse } from "../Custom Components/customer_error_response";

const events = [
  {
    id: 1,
    type: "Farm Training",
    title: "Kryzen Biotech Hydroponic Farm Training",
    date: "20 - 21 December 2025",
    location: "Kryzen Biotech, Satara",
    slug: "kryzen-biotech-farm-training-december",
    url:"https://kryzen.com/farm-training/",
    description:
      "A 2-day intensive hydroponics training program covering nutrient science, farm setup, crop planning, and commercial project feasibility. Ideal for beginners and entrepreneurs.",
  },
  {
    id: 2,
    type: "Webinar",
    title: "Hydroponics Business & Urban Farming Webinar",
    date: "Every Fri, Sat & Sun",
    location: "Online Webinar",
    slug: "hydroponics-business-webinar",
    url:'https://alpha.kryzen.com/hydroponic-webinar?theme=light',
    description:
      "A weekly online webinar explaining hydroponic systems, ROI calculation, business models, and investment planning for aspiring growers across India.",
  },
  {
    id: 3,
    type: "Exhibition",
    title: "KISAN Agri Exhibition 2025",
    date: "10 - 14 December 2025",
    location: "Pune, Maharashtra",
    slug: "kisan-agri-exhibition-pune",
    url:"https://pune.kisan.in/",
    description:
      "India’s biggest agricultural expo featuring hydroponics, greenhouse automation, AgriTech innovations, and advanced farming tools from global brands.",
  },
];

const EventCards = () => {
  const navigate = useNavigate();

  const [upcomingData, setUpcomingData] = React.useState([]);

    function formatFarmTrainingDate(dateStr) {
      const date = new Date(dateStr);
    
      // One day before
      const prevDate = new Date(date);
      prevDate.setDate(prevDate.getDate() + 1);
    
      const options = { day: "numeric", month: "long", year: "numeric" };
    
      const currentDay = date.getDate();
      const prevDay = prevDate.getDate();
    
      const monthYear = date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
    
      return `${currentDay} - ${prevDay} ${monthYear}`;
    }
  
    useEffect(() => {
      performRequest("GET", "/farmTraining/getUpcomingFarmTrainings")
        .then((res) => {
          if (res.status === 200) {
  
            setUpcomingData(res?.data?.upcomingTrainings);
          } else {
            Toast("error", "Error while getting Data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
      // .finally(() => setLoading(false));
    }, []);

  return (
    <div className="container">

      {/* Modern Section Heading */}
  

      {/* Cards */}
      <div className="row row-cards row-deck row-cols-1 row-cols-md-3 mt-4 g-4">

        {events?.map((event) => (
          <div key={event?.id} className="col">
            <div
              className="card h-100 shadow-sm border-0  d-flex flex-column hover-shadow"
              style={{
                transition: "all 0.25s ease",
                border: "1px solid var(--tblr-border-color)",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
                  <span className=" bg-green-lt text-green  text-center fs-2 fw-bold mb-3  py-2 ">
                {event.type}
              </span>
             <div className="p-3">
                 {/* Event Type */}


              {/* Title */}
              <h3 className="fw-semibold mb-2" style={{ color: "var(--tblr-dark)" }}>
                {event.title}
              </h3>

              {/* Date & Location */}
              <p className="text-muted small mb-1">
                <span className="text-green">📅</span> { event.id === 1 ? formatFarmTrainingDate(upcomingData?.farmTrainingDate) : event.date }
              </p>
              <p className="text-muted small mb-3">
                <span className="text-green">📍</span> {event.location}
              </p>

              {/* Description */}
              <p className="text-muted flex-grow-1">
                {event?.description.length > 140
                  ? `${event.description.substring(0, 140)}...`
                  : event?.description}
              </p>

             </div>
              {/* Button */}
              <div className="mt-auto p-3">
                <button
                  onClick={() => navigate(event?.url)}
                  className="btn btn-outline btn-green w-100 fw-bold py-2 mt-3"
                  style={{
                    borderRadius: "10px",
                  }}
                >
                  View Details
                </button>
              </div>

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default EventCards;
